import i18next from "i18next";
import { useTranslation } from "react-i18next";

const TermsPage = () => {
  const { t, i18n } = useTranslation();

  const terms = t("termsBody", { returnObjects: true });

  return (
    <div dir={i18next.language === "ar" ? "rtl" : "ltr"} className={`px-4 py-8 max-w-3xl mx-auto ${i18n.language === "ar" ? "text-right" : "text-left"}`}>
      <h1 className="text-2xl font-bold mb-6">{t("termsTitle")}</h1>
      {terms.map((section, index) => (
        <div key={index} className="mb-6">
          <h2 className="font-semibold text-lg mb-2">{section.title}</h2>
          <ul className="list-disc pl-6 space-y-1">
            {section.items.map((item, idx) => (
              <li key={idx} className="leading-relaxed">{item}</li>
            ))}
          </ul>
          <hr className="my-4 border-gray-300" />
        </div>
      ))}
    </div>
  );
};

export default TermsPage;
